import jump from 'jump.js';

export function initJumpLink(link) {
	if (link) {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const masthead = document.querySelector('#masthead');
			const adminBar = document.querySelector('#wpadminbar');
			const mastheadRect = masthead ? masthead.getBoundingClientRect() : null;
			let offset = mastheadRect ? mastheadRect.height : 0;
			if (adminBar) {
				const adminBarRect = adminBar ? adminBar.getBoundingClientRect() : null;
				offset = adminBarRect ? (offset + adminBarRect.height) : offset;
			}
			jump(link.getAttribute('href'), {
				duration: 360,
				offset: offset * -1,
			});
		});
	}
}

export function initJumpLinks() {
	const links = document.querySelectorAll('.pbsm-jump-link');
	if (links && (links.length > 0)) {
		links.forEach((link, i) => {
			initJumpLink(link);
		});
	}
}
